import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallMoved({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={8} cy={8} r={8} />
        <path
          d="M11.48 7.39L9 4.76c-.16-.1-.33-.21-.54-.21-.43 0-.8.38-.8.8 0 .22.1.43.26.6l1.15 1.22H5.05c-.42 0-.8.38-.8.8 0 .44.38.81.8.81h4.02l-1.15 1.27a.86.86 0 00-.26.6c0 .42.37.8.8.8.21 0 .38-.06.54-.22l2.48-2.66a.86.86 0 00.27-.6c0-.2-.1-.42-.27-.58z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgTickSmallMoved.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallMoved.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickSmallMoved svgRef={ref} {...props} />);
export default ForwardRef;
